/* @flow */

import { callApiEndpoint } from './index';
import utils from './utils';

import type { BroadcastType, FindBroadcastTypeParams } from 'types';

const find = async (params: ?FindBroadcastTypeParams): Promise<BroadcastType[]> => {
  const { productionTypeId, usageTypeId } = params || {};
  let pathUrl = (productionTypeId || 3) + '/' + (usageTypeId || 2);
  const response = await callApiEndpoint(
    'tipologieemissione/' + pathUrl + '/findByTipologiaProduzioneAndTipologiaUtilizzo',
    { params: {} }
  );
  return response.map(utils.toBroadcastType);
};

export default {
  find,
};
